/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stealth_Access_PlaceholderInputs */



/**
* | output |
* | --- |
* | "you@company.com" |
*
* @param {Stealth_Access_PlaceholderInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const stealth_access_placeholder = /** @type {((inputs?: Stealth_Access_PlaceholderInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stealth_Access_PlaceholderInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("you@company.com")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("du@foretag.se")
	return /** @type {LocalizedString} */ ("deg@firma.no")
});